// index.js
import React from 'react';
import ReactDOM from 'react-dom/client';  // Import from 'react-dom/client'
import { Provider } from 'react-redux';
import store from './redux/store/store';
import App from './App';
import './index.css';  // Optional: your global styles

// Create a root
const root = ReactDOM.createRoot(document.getElementById('root'));

// Render your app with the Provider wrapping it
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);

